import type { HTMLAttributes } from "react";

import { HorizontalRuleMarginOptions, Root } from "./styles";

export type HorizontalRuleProps = {
  /**
   * Vertical margin placement
   */
  margin?: HorizontalRuleMarginOptions;
} & HTMLAttributes<HTMLHRElement>;

/**
 * A horizontal rule, useful for separating sections of content.
 */
export function HorizontalRule({ margin = "both", ...rest }: HorizontalRuleProps): JSX.Element {
  return <Root data-testid={HorizontalRule.name} margin={margin} {...rest} />;
}
